import Button from "@components/button";
import { createLinkComponent } from "react-native-ridge-navigation";

const ButtonLink = createLinkComponent(Button);
export default ButtonLink;
